// Add data-behaviour="toggleable" to allow the element to toggle the visibility of the target
// Define the target with data-target=".some_selector"
jQuery(function () {
  var toggleableItemsToInit = "[data-behaviour~=toggleable][data-toggled-state]";
  var ignoreSelector = "[data-behaviour~=close-on-clickout]";

  // BEHAVIOUR

  jQuery(document).on("toggleable:init", initState);

  jQuery(document).on("click", closeOnClickout);

  jQuery(document).on("click", "[data-behaviour~=toggleable]", function (event) {
    event.preventDefault();
    toggleOne(this);
    if (jQuery(this).data("toggled-on-text") && jQuery(this).data("toggled-off-text")) {
      const state = this.classList.contains(jQuery(this).data("toggle-class"));
      const labelText = jQuery(this).data("toggled-" + (!state ? "on" : "off") + "-text");
      jQuery(this).text(labelText);
    }
  });

  // INITALIZATION

  initState();

  // HELPER FUNCTIONS

  function closeOnClickout(event) {
    var ignoreClick = jQuery(event.target).closest(ignoreSelector).length;

    if (!ignoreClick) {
      var element = jQuery(ignoreSelector).find("[data-behaviour~=toggleable]");
      toggleOne(element, false);
    }
  }

  function toggleOne(trigger, state) {
    var target = jQuery(trigger).data("target");
    var klass = jQuery(trigger).data("toggle-class");
    var duration = jQuery(trigger).data("duration");
    if (klass) {
      jQuery(trigger).toggleClass(klass, state);
    }
    jQuery(target).toggle(duration ? duration : state);
  }

  function initState() {
    jQuery(toggleableItemsToInit).each(function () {
      toggleOne(this, jQuery(this).data("toggled-state"));
    });
  }
});
